export default {
  VERSION: '0.0.01',
  MAYA_API: 'https://api.maya.tech/otc',
  DEFAULT_LANGUAGE: 'en_US',
  SUPPORT_NUMBER: '+1 (855) 781-7277',
  STATIC_PATH: 'https://atm.cm',
  // Timeouts (in seconds)
  TIMEOUT: 1500, // 25 min
  INTERNAL_TIMEOUT: 300, // 5 min
  SCANNER_URL: 'http://localhost:8009'
};


// WEBPACK FOOTER //
// ./src/config/prod.js